import tickCircleSVG from "../../../images/bf-tick-circle.svg?url"
import redDangerSVG from "../../../images/bf-red-danger.svg?url"

export const kycStatus = {
  verified: {
    label: "Verified",
    color: "#2D9C5E",
    icon: tickCircleSVG,
  },
  unverified: {
    label: "Unverified",
    color: "#e02020",
    icon: redDangerSVG,
  },
  pending_verification: {
    label: "Verification Pending",
    color: "#ff6f00",
    icon: "",
  },
  expired_verification: {
    label: "Verification Expired",
    color: "#ff6f00",
    icon: "",
  },
  awaiting_verification: {
    label: "Awaiting Verification",
    color: "#ff6f00",
    icon: "",
  },
  rejected: {
    label: "Verification Rejected",
    color: "#e02020",
    icon: redDangerSVG,
  },
  incomplete: {
    label: "Verification Incomplete",
    color: "#ff6f00",
    icon: "",
  },
  fully_verified: {
    label: "Fully Verified",
    color: "#2D9C5E",
    icon: tickCircleSVG,
  },
  part_verified: {
    label: "Part Verified",
    color: "#ff6f00",
    icon: "",
  },
};
